import React from 'react'

export default class SaveStatus extends React.Component
{		
	constructor(props)
	{
		super(props);

    	// Create a state item here for all items on the form  (Using their id )
		this.state = {val: this.props.value, types: null};

		this.onClick = this.onClick.bind(this) ;
	}
	
	getValue ( )
	{
		return 12 ;
	}

	onClick()
	{
		if ( this.props.onClick != null )
		{
			this.props.onClick() ;
		}
	}

	renderedComponent()
	{
        var lineList = [] ;

        if ( this.props.dirty == true )
		{
            lineList.push (React.createElement ( 'div', { key: 'outerSave', className: 'tab-save-status tab-save-status-dirty glyphicon glyphicon-floppy-remove', onClick: this.onClick}),
                React.createElement ('div', { key: 'innerSave', className: 'saveIcon' })) ;
		}
		else
		{
            lineList.push (React.createElement ( 'div', { key: 'outerSave', className: 'tab-save-status tab-save-status-clean glyphicon glyphicon-floppy-saved', onClick: this.onClick}),
                React.createElement ('div', { key: 'innerSave', className: 'saveIcon' })) ;
		}

        return lineList ;
	}
	
    render() 
    { 
    	return this.renderedComponent() ;
    }
}


